/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddVehicleRequestApiFrom } from '../../models/add-vehicle-request-api-from';
import { VehicleApiFrom } from '../../models/vehicle-api-from';

export interface ApiV3ServiceAddVehiclePost$Params {

/**
 * Interface language
 */
  lang?: string;
      body?: AddVehicleRequestApiFrom
}

export function apiV3ServiceAddVehiclePost(http: HttpClient, rootUrl: string, params?: ApiV3ServiceAddVehiclePost$Params, context?: HttpContext): Observable<StrictHttpResponse<VehicleApiFrom>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceAddVehiclePost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VehicleApiFrom>;
    })
  );
}

apiV3ServiceAddVehiclePost.PATH = '/api/v3/service/AddVehicle';
